import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, getPromoMenus, getLayout, ensureBoolean } from '../../lib/ep.js';

import BackgroundImage from './BackgroundImage.js';

import FooterFlex from './FooterFlex';
import MainMenuFlex from './MainMenuFlex';
import { usePromotion } from '../context/promotionContext.js';
import AgeRestriction from './layers/AgeRestriction.js';

const default_props = {
	bg_color:'bl',
	width:50,
	button:'solid',
	text_align:'cc',
	icons:'knk',
};

const LayoutFlex = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let { PromoModel, promotion } = usePromotion();
	
	if(props.promo != undefined) promotion = { ...props.promo };
	const is_builder = props?.is_builder ?? false;

	const [ display_age_restriction, setDisplayAgeRestriction ] = useState((!is_builder) ? PromoModel.displayAgeRestriction() : false);
	if(promotion.config == undefined) promotion.config = {};

	promotion.layout_props = getLayout(promotion);

	const only_contents = props?.only_contents ?? false;
	const hide_contents = props?.hide_contents ?? false;
	const is_managing_section = props?.is_managing_section ?? false;
	const without_context = props?.without_context ?? false;
	const is_transparent = props?.is_transparent ?? false;
	const hide_wrapper = props?.hide_wrapper ?? false;
	const not_promotion = props?.not_promotion ?? false;
	const page = props?.page ?? null;
	const is_participate = props?.is_participate ?? false;

	const layout = promotion?.config?.layout ?? {};

	let display_header = props?.display_header ?? true;
	if(promotion.config.custom_menu != undefined && promotion.config.custom_menu.status == '0') display_header = false;
	
	let display_footer = props?.display_footer ?? true;
	if(promotion.display_footer != undefined && !promotion.display_footer) display_footer = false;

	const default_locale = promotion?.default_locale ?? 'eng';
	const current_lang = props?.current_lang ?? default_locale;

	useEffect(() => {
		if(is_builder && !without_context && $('.device_area').width() != undefined) {
		//	$('.background_opacity').prependTo('.device_area');
		//	$('.promo_bg').prependTo('.device_area');
		}
	}, []);

	const templateDefaults = (page = 'landing') => {
		if(page == 'landing') return { width:60 };
		if(page == 'entries') return { width:90 };
		if(page == 'quiz') return { width:70 };
		if(page == 'winners') return { width:70 };
		if(page == 'stage_mosaic' || page == 'galleries_mosaic') return { width:70 };
		//if(page == 'galleries_mosaic') return { width:70 };
		if(page == 'brackets_mosaic') return { width:70 };
		if(page == 'cv') return { width:100 };
		if(page == 'my_prizes') return { width:70 };
		if(page == 'claim') return { width:70 };
		return { width:50 };
	};

	const flexBackground = () => {
		let cls = ['flex_container'];

		if(hide_wrapper) cls.push('hide_wrapper');

		const bg = layout.bg_color ?? default_props.bg_color;
		const alpha = (!is_transparent) ? (layout.alpha ?? 100) : 0;
		cls.push(`_a${bg}${alpha}`);

		const text_align = layout.text_align ?? default_props.text_align;
		cls.push(`_align_text_${text_align}`);

		return cls.join(" ");
	};

	const templateClass = (page = 'winners') => {
		let cls = ['template_minimal'];

		if(not_promotion !== false) {
			cls.push('sweep_container gui_pos_rel landing_page _prop30 single_columned');

			switch(not_promotion) {
				case 'terms':
					cls.push('full_height pos_tc');
					return cls.join(" ");

				case 'sweeps':
				default:
					cls.push('adapt_height pos_tc');
					return cls.join(" ");
			}
		}

		cls.push(`${page}_page`);
		promotion.template_id = parseInt(promotion.template_id);

		//Width
		let size = promotion?.config?.layout.width ?? templateDefaults(page).width;
		let num_cols_class = 'single_columned';
		let cols_prop_class = '40';

		if(props.custom_layout != undefined) {
			if(props.custom_layout.width != undefined) size = props.custom_layout.width;
			if(props.custom_layout.num_cols != undefined) num_cols_class = (props.custom_layout.num_cols == 2) ? 'double_columned' : 'single_columned';
			if(props.custom_layout.cols_prop != undefined) cols_prop_class = props.custom_layout.cols_prop;
		} else if(layout != undefined && layout[page] != undefined) {
			if(layout[page].width) size = layout[page].width;
			if(layout[page].num_cols == 2) num_cols_class = 'double_columned'
			if(layout[page].cols_prop) cols_prop_class = layout[page].cols_prop;
		}

		if(size) cls.push(`_wg${size}`);

		cls.push(`_prop${cols_prop_class}`);
		if(layout && layout.container_align != undefined) {
			if((promotion?.has_ranking ?? false) && (page == 'entries' || page == 'ranking')) {
				cls.push(`pos_t${layout.container_align.substr(-1)}`);
			} else {
				cls.push(`pos_${layout.container_align}`);
			}
		}

		cls.push(num_cols_class);

		//Background
		//const bg = layout.bg_color ?? default_props.bg_color;
		//if(bg) cls.push(`${bg}_bg`);

		//Texts
		//const text_color = layout.text_color ?? default_props.text_color;
		//if(text_color) cls.push(`${text_color}_text`);

		return cls.join(" ");
	};

	let total_locs = { [default_locale]:default_locale };
	if(promotion.promo_type == '2' && is_builder) {
		window.langs.map((loc) => {
			total_locs[loc.I18nPromotion.lang] = loc.I18nPromotion.lang;
		});
	}

	const menus = (PromoModel != undefined) ? PromoModel.menus : ((props.menus != undefined) ? getPromoMenus(props.menus, promotion) : []);

	const builder_id = (hide_contents) ? 'promo_layout_hide_contents' : 'promo_builder_canvas';

	var mainFlexWrapperClass = ['main_flex_wrapper'];
	if((promotion.config.show_footer != undefined && promotion.config.show_footer == '0') || !display_footer) mainFlexWrapperClass.push('without_footer');
	if(!display_header) mainFlexWrapperClass.push('without_header');
	if(props.layout_extra_classes != undefined && props.layout_extra_classes) mainFlexWrapperClass.push(props.layout_extra_classes);

	if(is_participate) {
		if(promotion.is_full_container != undefined && promotion.is_full_container) mainFlexWrapperClass.push('is_full_container');
		if(promotion.is_game != undefined && promotion.is_game) mainFlexWrapperClass.push('is_game');
	}

	const flexContainerClass = flexBackground();
	var flexTemplateClass = templateClass(page);
	if(is_builder) flexTemplateClass += ' is_builder';

	const main_container_id = (!is_builder) ? 'ep_main_container' : 'layout_in_builder_container';

	const main_classes = ['gui_pos_rel', flexTemplateClass];

	const common_styles = { height:'100%' };

	let contents_css = { flexGrow:'1' };
	if(is_builder) {
		main_classes.push('front_3');
		main_classes.push('ep_global_contents');

		const has_tabs = props?.has_tabs ?? true;
		contents_css['--test-msg-h'] = (has_tabs) ? '120px' : '80px';
	}

	const main_styles = (!is_builder) ? { minHeight:'100dvh' } : null;

	if(not_promotion !== false) {
		return (
			<div id={(!is_builder) ? 'ep-global-contents' : null} class={main_classes.join(" ")} style={main_styles}>
				<section id={(!is_builder) ? 'ep-contents' : builder_id} class="whole_promo_container" style={contents_css}>
					<section id={main_container_id} class="awesome" style={common_styles}>
						<section class="template_contents" style={(is_builder) ? common_styles : null}>
							{(props.children != undefined) ? (
								<article class="template_display">
									<section class={mainFlexWrapperClass.join(" ")}>
										<article class={flexContainerClass}>
											{props.children}
										</article>
									</section>
								</article>
							) : (
								<article class="template_display" style={{opacity:'0'}} />
							)}

							<FooterFlex
								is_builder={is_builder}
								custom_footer={i18n("Made with Easypromos")}
								styles={{ border:'none' }}
							/>
						</section>
					</section>

					<aside id="gui_modal_root_public" class="awesome" />
				</section>
			</div>
		)
	}

	if(only_contents) {
		let dom_classes = [flexTemplateClass, 'without_context', 'awesome', 'layout_with_only_contents'];

		if(is_builder) {
			const vars_dom_class = 'css_var_root';
			dom_classes.push(vars_dom_class);
		}

		return (
			<section class={dom_classes.join(" ")}>
				<section class={mainFlexWrapperClass.join(" ")}>
					<article class={flexContainerClass}>
						{props.children}
					</article>
				</section>

				<aside id="gui_modal_root_public" class="awesome" />
			</section>
		)
	}

	if(without_context) main_classes.push('without_context');
	if(hide_contents) main_classes.push('hide_contents');

	const force_full_on_mobile = promotion?.layout_props?.container?.full_on_mobile ?? false;
	if(force_full_on_mobile) main_classes.push('force_full_on_mobile');

	return (
		<div id={(!is_builder) ? 'ep-global-contents' : null} class={main_classes.join(" ")} style={main_styles}>
			{(!without_context) && (
				<BackgroundImage
					promotion={promotion}
					force_bg_image={props.force_bg_image}
					is_builder={is_builder}
				/>
			)}

			{(!without_context && display_header) && (
				<MainMenuFlex
					ref={(!is_builder) ? (e) => { window.menu_ref = e } : null}
					promo={promotion}
					loyalty_tokens={props.loyalty}
					is_builder={is_builder}
					force_display={props.force_display_menu}
					force_type={props.force_header_type}
					menus={menus}
					actual_page={props.page}
					share_info={props?.common?.share_info ?? props?.share_info}
					login_id={props.login_id}
					login_data={props.login_data}
					hide_menu={props.hide_menu}
					intl={props.intl}
				/>
			)}

			{(!hide_contents) && (
				<section id={(!is_builder) ? 'ep-contents' : builder_id} class="whole_promo_container" style={contents_css}>
					<section id={main_container_id} class="awesome" style={common_styles}>
						<section class="template_contents" style={(is_builder) ? common_styles : null}>
							{(props.children != undefined) ? (
								<article class="template_display">
									<section class={mainFlexWrapperClass.join(" ")}>
										<article class={flexContainerClass}>
											{props.children}
										</article>
									</section>
								</article>
							) : (
								<article class="template_display" style={{opacity:'0'}} />
							)}

							{(!without_context && display_footer) && (
								<FooterFlex
									promo={promotion}
									locs={is_builder ? total_locs : props.langs}
									current_lang={current_lang}
									localized_locales={is_builder ? window.available_langs : props.langs}
									is_builder={is_builder}
									is_managing_section={is_managing_section}
								/>
							)}
						</section>
					</section>
				</section>
			)}

			<aside id="gui_modal_root_public" class="awesome" />

			{(!is_builder && display_age_restriction) && (
				<AgeRestriction
					promotion={promotion}
					onAgeSelected={(data) => {
						setDisplayAgeRestriction(false);
						setCookie(`age_restriction_${promotion.id}`, data, 2, `.${props.domain}`);
					}}
				/>
			)}
		</div>
	);
}

export default injectIntl(LayoutFlex);